import { loadingViewComponent } from "app/main/common/LoadingView";
import { strategyConnect } from "../../providers/StrategyContextProvider";
import StrategyVisualizer from "../strategy-visualizer/StrategyVisualizer";
import StrategyList from "../strategy-list/StrategyList";
import StrategyHeader from "../strategy-header/StrategyHeader";

const StrategyLoadingContainer = ({ loading, children, viewMode, topLevel }) => {
	return loading ? (
		loadingViewComponent(topLevel === "savedList" ? "Loading..." : "Generating contract...")
	) : viewMode === "tree" ? (
		<div>
			<StrategyHeader />
			<StrategyVisualizer />
		</div>
	) : (
		<div>
			<StrategyHeader />
			<StrategyList />
		</div>
	);
};

const mapStateToProps = (state) => ({
	loading: state.loading,
	viewMode: state.viewMode,
	topLevel: state.topLevel,
});

export default strategyConnect(mapStateToProps)(StrategyLoadingContainer);
